import { Injectable, inject } from '@angular/core';
import { Auth, User, user } from '@angular/fire/auth';
import { Database, objectVal, ref } from '@angular/fire/database';
import { of, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private database: Database = inject(Database);
  private auth: Auth = inject(Auth);
  private user$ = user(this.auth);

  getProfile () {
    return this.user$.pipe(
      switchMap(aUser => !aUser? of(null) : objectVal(ref(this.database, 'usuarios/'+ aUser?.uid)) )
    );
  }
  
}